// actions.js
const actions = {
  UPDATE_EMAIL_READ: 'UPDATE_EMAIL_READ',
  UPDATE_EMAIL_READ_SUCCESS: 'UPDATE_EMAIL_READ_SUCCESS',
  UPDATE_EMAIL_READ_FAILED: 'UPDATE_EMAIL_READ_FAILED',

  GET_MAILS_DATA: 'GET_MAILS_DATA',
  GET_MAILS_DATA_SUCCESS: 'GET_MAILS_DATA_SUCCESS',
  GET_MAILS_DATA_FAILED: 'GET_MAILS_DATA_FAILED',

  updateEmailRead: (data , agentId) => ({
  
      type: actions.UPDATE_EMAIL_READ,
      payload: { data , agentId },
  }),
  updateEmailReadSuccess: (message) => ({
      type: actions.UPDATE_EMAIL_READ_SUCCESS,
      payload: { message },
  }),
  updateEmailReadFailed: (error) => ({
      type: actions.UPDATE_EMAIL_READ_FAILED,
      payload: { error },
  }),

  getMailsData: (offset, limit, search, fromDate, toDate, agentId) => ({
    type: actions.GET_MAILS_DATA,
    payload: { offset, limit, search, fromDate, toDate, agentId },
  }),
  getMailsDataSuccess: (data, totalData) => ({
    type: actions.GET_MAILS_DATA_SUCCESS,
    payload: { data, totalData },
  }),
  getMailsDataFailed: (error) => ({
    type: actions.GET_MAILS_DATA_FAILED,
    payload: { error },
  }),
};

export default actions;
